import React from 'react';

const Expandable: React.FC<{
  height: number | string | undefined;
  innerRef: React.RefObject<HTMLDivElement>;
  className?: string;
}> = ({ children, height, innerRef, className }) => {
  return (
    <div className={className} style={{ height }} ref={innerRef}>
      {children}
    </div>
  );
};

export default Expandable;
